export default class SearchViniedoPModel {
    constructor(data = {}) {
        this.viniedo = data.viniedo || '';
        this.departamento = parseInt(data.departamento) || 0;
        this.habilitado = parseInt(data.habilitado) || 0;
        this.titular = data.titular || '';
        this.seccional = parseInt(data.seccional) || 0;
        this.padron = data.padron || '';
    }
}
